import { Button } from "@portal/BaseComponents/Button/AntButton";
import { DocPreview } from "@portal/BaseComponents/Document/DocViewer/Preview/DocPreview";
import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import { TextColumn } from "@portal/BaseComponents/Table/Components/Text/TextColumn";

import useOpen from "@portal/hooks/useOpen";
import { Icon } from "@portal/lib/icons/icons";
import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { usePageNavigate } from "@portal/lib/router/hooks/usePageNavigae";
import { usePreviewAttachmentQuery } from "@portal/queries/download-query";
import { Invoice } from "@portal/types/entities/invoice";
import { FileType } from "@portal/types/file";
import { CellRenderProps } from "@sinecycle/growcomponents";
import { message, Row } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";

const pdfIcon = <Icon icon={["far", "file-pdf"]} color="var(--red-7)" />;
function ReferenceCell(props: CellRenderProps<Invoice>) {
  const { data } = props;
  const { customer_id } = useParams<AppPageParams>();
  const mutate = usePreviewAttachmentQuery();
  const { open, onClose, toggleOpen } = useOpen({ open: false });
  const [url, setUrl] = useState<string>();
  const [messageApi, contextHolder] = message.useMessage();
  function getUrl() {
    if (!data?.attachment_id) return;
    messageApi.open({
      type: "loading",
      content: "Action in progress..",
      duration: 1,
      key: "Loader",
    });
    mutate.mutateAsync(data.attachment_id).then((value) => {
      setUrl(value.expiry_link);
      toggleOpen();
    });
  }
  const navigate = usePageNavigate();
  const PdfIcon = (
    <HideWrapper hide={data?.attachment_id ? false : true}>
      <Button
        icon={pdfIcon}
        onClick={getUrl}
        iconButton="without_bg"
        loading={mutate.isLoading}
      />
    </HideWrapper>
  );
  function handleQueryParams() {
    navigate({
      appPage: "INVOICE_DETAILS",
      pathParams: {
        invoice_id: data?.id as string,
        customer_id: customer_id as string,
      },
      replace: true,
      state: null,
    });
  }

  function handleLoad() {
    message.destroy("Loader");
  }
  return (
    <Row  wrap={false}>
      {contextHolder}
      <TextColumn
        type="Text"
        text={data?.number}
        suffix={PdfIcon}
        textProps={{
          onClick: handleQueryParams,
          strong: true,
          style: { color: "var(--primary-7)", cursor: "pointer" },
        }}
        style={{
          width: "100%",
        }}
      />
      <DocPreview
        docType={FileType.PDF}
        docUrl={url}
        open={open}
        onClose={onClose}
        onLoad={handleLoad}
      />
    </Row>
  );
}

export { ReferenceCell };
